import { format, isEqual, parseISO } from "date-fns";

import { type DateInterval } from "@north-beam/nb-common";

const DATE_FORMAT = "MMM dd, yyyy";

export function formatDateRange({ startDate, endDate }: DateInterval) {
  const start = parseISO(startDate);
  const end = parseISO(endDate);

  if (isEqual(start, end)) {
    return format(start, DATE_FORMAT);
  } else {
    return `${format(start, DATE_FORMAT)} – ${format(end, DATE_FORMAT)}`;
  }
}
